"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const SelectInput_styles_1 = require("./SelectInput.styles");
const SelectInputWrapper_1 = __importDefault(require("./SelectInputWrapper"));
const SelectBaseInput = styled_components_1.default.select(({ theme }) => theme.inputs.select, (0, util_theme_sxc_1.sx2CssThemeFn)(({ hasIcon }) => (0, SelectInput_styles_1.getSelectInputForceStyles)(hasIcon)));
const SelectInput = (props) => {
    const { name, value, defaultValue, onChange, options, label, hideLabel, icon, testId, className, required, customLabel, customChevronArrow } = props, otherProps = __rest(props, ["name", "value", "defaultValue", "onChange", "options", "label", "hideLabel", "icon", "testId", "className", "required", "customLabel", "customChevronArrow"]);
    const onSelectChange = (e) => {
        const nextValue = e.target.value;
        onChange(nextValue, e);
    };
    return (react_1.default.createElement(SelectInputWrapper_1.default, { name: name, label: label && (react_1.default.createElement(react_1.default.Fragment, null,
            label,
            " ",
            required ? react_1.default.createElement("span", null, "*") : '')), customLabel: customLabel, hideLabel: hideLabel, icon: icon, className: className, customChevronArrow: customChevronArrow },
        react_1.default.createElement(SelectBaseInput, Object.assign({ id: name, name: name, value: value, defaultValue: defaultValue, onChange: (e) => onSelectChange(e), hasIcon: !!icon, "data-id": testId, className: "input" }, otherProps), options.map(option => {
            return (react_1.default.createElement("option", { key: option.value, value: option.value, "data-id": option.testId, disabled: option.disabled }, option.label));
        }))));
};
exports.default = SelectInput;
//# sourceMappingURL=SelectInput.js.map